import { FC, ReactNode } from 'react';

import cloudLogo from 'assets/vectors/scp-cloud.svg';
import logo from 'assets/vectors/hq-logo.png';

import { MenuItem } from 'models';
import * as routes from 'router/Routes';

import HamburgerButton from 'components/UI/HamburgerButton';
import TabMenu from 'components/UI/TabMenu';

import {
  Logo,
  Container,
  TopBorder,
  Content,
  PrimaryArea,
  SecondaryArea,
  SideArea,
  LogoLink,
  ActionMenu,
  Menu,
  MobileLogo,
  MobileMenu
} from './styled';

type Props = {
  children?: ReactNode;
  leftMenu: MenuItem[];
  rightMenu?: MenuItem[];
  setMobileMenuOpen: (isOpen: boolean) => void;
  mobileMenuOpen: boolean;
};

const NavBar: FC<Props> = ({
  children,
  leftMenu,
  rightMenu,
  mobileMenuOpen,
  setMobileMenuOpen
}) => {
  return (
    <Container>
      <TopBorder />
      <Content>
        <PrimaryArea>
          <LogoLink to={routes.DEVICES}>
            <MobileLogo src={cloudLogo} alt="husqvarna developers" />
            <Logo src={logo} alt="husqvarna developers" />
          </LogoLink>
          <Menu>
            <TabMenu menuItems={leftMenu} includeSub />
          </Menu>
        </PrimaryArea>
        {rightMenu && (
          <SecondaryArea>
            <TabMenu menuItems={rightMenu} includeSub />
          </SecondaryArea>
        )}
        <ActionMenu>
          <svg width="40" height="56">
            <path
              d="m24.85 11.538-9.41 32.924A15.905 15.905 0 0 1 .14 56V0h40c-7.1 0-13.34 4.709-15.29 11.538Z"
              fill="#FFF"
              fillRule="nonzero"
            />
          </svg>
          <SideArea>
            {children}
            <MobileMenu>
              <HamburgerButton
                isOpen={mobileMenuOpen}
                setIsOpen={setMobileMenuOpen}
              />
            </MobileMenu>
          </SideArea>
        </ActionMenu>
      </Content>
    </Container>
  );
};

export default NavBar;
